<section class="title-bar content-padding first-item">
  <div class="wrapper">
    <h2 class="left">Team Leader</h2>
    <br class="clear">
    <div class="right">
      <a routerLink="nuovo" class="ml-10">
        <span class="btn btn-white" id="addSmsTemplate">Aggiungi<i class="ml-10 fas fa-plus"></i></span>
      </a>
    </div>
  </div>
  <br class="clear">
</section>

<section class="main-content wrapper content-padding">
  <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage"></app-pagination>
  <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
    <form class="table-row-container row first-row filter" [formGroup]="teamLeaderFilterForm" (ngSubmit)="filter()" *ngIf="teamLeaderFilterForm">
      <div class="item data-col-10 hideOnPhoneView">
        <h4 class="title" (click)="navigateOrder('TeamLeader.id')">
          <i class="sort-icon fas" [ngClass]="orderIcon('TeamLeader.id')"></i>
          ID
        </h4>
        <span class="data">
          <input type="number" formControlName="TeamLeader.id" min="1000" max="10000">
        </span>
      </div>

      <div class="item data-col-15">
        <h4 class="title" (click)="navigateOrder('User.surname')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
          Cognome
        </h4>
        <span class="data">
          <input type="text" formControlName="User.surname">
        </span>
      </div>

      <div class="item data-col-15 expertClass">
        <h4 class="title" (click)="navigateOrder('User.name')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
          Nome
        </h4>
        <span class="data">
          <input type="text" formControlName="User.name">
        </span>
      </div>

      <div class="item data-col-15 expertClass">
        <h4 class="title" (click)="navigateOrder('Provinces.provinceCode')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.provinceCode')"></i>
          Province
        </h4>
        <span class="data">
          <input type="text" formControlName="Provinces.provinceCode">
        </span>
      </div>

      <div class="item data-col-15 center expertClass">
        <h4 class="title" (click)="navigateOrder('User.email')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
          Email
        </h4>
        <span class="data">
          <input type="text" formControlName="User.email">
        </span>
      </div>

      <div class="item data-col-10 center expertClass">
        <h4 class="title" (click)="navigateOrder('TeamLeader.phone')">
          <i class="sort-icon fas" [ngClass]="orderIcon('TeamLeader.phone')"></i>
          Telefono
        </h4>
        <span class="data">
          <input type="text" formControlName="TeamLeader.phone">
        </span>
      </div>

      <div class="item data-col-10 center">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          Attivo
        </h4>
      </div>

      <div class="item data-col-5 hideOnPhoneView">
        <h4 class="title">Azioni</h4>
        <span class="data saifu">
          <button class="btn hvr-grow" (click)="$event.preventDefault(); filter()">
            <i class="fas fa-search"></i>
          </button>
          <button class="btn hvr-grow" (click)="$event.preventDefault(); resetFilter()">
            <i class="fas fa-undo"></i>
          </button>
        </span>
      </div>
      <hr class="hr-clear">
    </form>

    <div class="table-row-container row" *ngFor="let teamLeader of teamleaders">
      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          ID
        </h4>
        <div class="data data-id">
          <div>{{ teamLeader?.id || "---" }}</div>
        </div>
      </div>

      <div class="item data-col-15">
        <h4 class="title" (click)="navigateOrder('User.surname')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
          Cognome
        </h4>
        <span class="data">
          <a [routerLink]="['/team/leader', 'edit', teamLeader?.id]">{{ teamLeader?.user?.surname || "---" }}</a>
        </span>
      </div>

      <div class="item data-col-15">
        <h4 class="title" (click)="navigateOrder('User.name')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
          Nome
        </h4>
        <span class="data">
          <a [routerLink]="['/team/leader', 'edit', teamLeader?.id]">{{ teamLeader?.user?.name || "---" }}</a>
        </span>
      </div>

      <div class="item data-col-15">
        <h4 class="title" (click)="navigateOrder('Provinces.provinceCode')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.provinceCode')"></i>
          Province
        </h4>
        <span>
          <div *ngIf="teamLeader?.teamLeaderProvinces.length > 0">
            <div *ngFor="let data of teamLeader?.teamLeaderProvinces; let last=last;">
              <a [routerLink]="['/team/leader', 'edit', teamLeader?.id]">
                <b>{{ data?.province?.provinceCode }}</b> {{ data?.province?.province }}
              </a>
              <ng-container *ngIf="!last">, </ng-container>
            </div>
          </div>
          <div *ngIf="teamLeader?.teamLeaderProvinces.length === 0">
            ---
          </div>
        </span>
      </div>

      <div class="item data-col-15 center">
        <h4 class="title" (click)="navigateOrder('User.email')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
          Email
        </h4>
        <span class="data">
          <a [routerLink]="['/team/leader', 'edit', teamLeader?.id]">{{ teamLeader?.user?.email || "---" }}</a>
        </span>
      </div>

      <div class="item data-col-10 center">
        <h4 class="title" (click)="navigateOrder('TeamLeader.phone')">
          <i class="sort-icon fas" [ngClass]="orderIcon('TeamLeader.phone')"></i>
          Telefono
        </h4>
        <span class="data">
          <a [routerLink]="['/team/leader', 'edit', teamLeader?.id]">{{ teamLeader?.phone || "---" }}</a>
        </span>
      </div>

      <div class="item data-col-10 center active">
        <br>
        <span class="data">
          {{ translateActive(teamLeader?.user?.active) }}
        </span>
      </div>

      <div class="item data-col-5">
        <h4 class="title"></h4>
        <span class="data saifu">
          <button class="btn hvr-grow has-margin-right has-margin-bottom has-margin-top" [routerLink]="['/team/leader', 'edit', teamLeader.id]">MODIFICA</button>
          &nbsp;
          <a (click)="$event.preventDefault(); deleteTeamLeader(teamLeader?.id)">
            <span class="btn btn-red hvr-grow">Elimina<i class="ml-10 far fa-trash-alt"></i></span>
          </a>
        </span>
      </div>
    </div>
  </div>
</section>
